import { render } from "./IceMakerButton.vue?vue&type=template&id=b3624e04"
import script from "./IceMakerButton.vue?vue&type=script&lang=js"
export * from "./IceMakerButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__